// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsGetPoolBody = {
  poolId: string;
};

export type typeNotificationSettingsGetPoolOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    poolId: string;
    followsGlobal: boolean;
    alerts: {
      alertKind:
        | "contestStarted"
        | "contestFinished"
        | "seasonStarted"
        | "poolSettingsChanged"
        | "pickReminder"
        | "roundGraded"
        | "eliminated"
        | "revived"
        | "spreadMoved"
        | "customAwardChanged"
        | "squaresLockUnlock"
        | "squaresGridPublished"
        | "squaresWinnerSet"
        | "squaresWinnerUpdated"
        | "squaresSquareAssigned"
        | "squaresScoreCorrection"
        | "stripCardLockUnlock"
        | "memberWaitingApproval"
        | "roundLocked"
        | "contestCorrected"
        | "stripCardStripAdded"
        | "stripCardFilled"
        | "stripCardSpotAssigned"
        | "stripCardSpotUnassigned"
        | "stripCardWinner"
        | "stripCardGameCanceled";
      group: "invite" | "pools" | "games" | "chat";
      email: { isEnabled: boolean; isLocked: boolean };
      inApp: { isEnabled: boolean; isLocked: boolean };
      phone: { isEnabled: boolean; isLocked: boolean };
      isOverridden: boolean;
    }[];
  };
};

export type typeNotificationSettingsGetPoolOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetPoolOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetPoolOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsGetPoolBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsGetPool(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaNotificationSettingsGetPoolBody);
  }

  return async function postNotificationSettingsGetPool(
    payload: typeNotificationSettingsGetPoolBody,
  ): Promise<
    | typeNotificationSettingsGetPoolOutput200
    | typeNotificationSettingsGetPoolOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsGetPool" failed before calling the network. #2e1d7559528a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#2e1d7559528a" },
        },
        data: null,
      } as typeNotificationSettingsGetPoolOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/get-pool`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsGetPoolOutput200
      | typeNotificationSettingsGetPoolOutput400;
  };
}
